import {
  ButtonType,
  DialogFooterButtonsWidget,
  RadioButtonWithLabelGroupWidget,
  RadioButtonWithLabelOption,
  TabStyles
} from '@tableau/widgets';
import React from 'react';
import { classes } from 'typestyle';

import { CommonStyles } from '~common/react/CommonStyles';
import { Messages } from '~src/codegen/Localize';
import { cssClass } from '~src/style';
import { IPublishedConnectionDetailInfo } from '~src/ts/models/IPublishedConnectionInfo';
import { IPublishedConnectionTaskInfo } from '~src/ts/models/IPublishedConnectionTaskInfo';
import { PublishedConnectionTaskRefreshTypeDropdown } from './PublishedConnectionTaskRefreshTypeDropdown';
import { PublishedConnectionTaskSchedulePicker } from './PublishedConnectionTaskSchedulePicker';

const cssPrefix = 'PublishedConnectionCreateTaskDialogContent';

const rootClass = cssClass(cssPrefix, 'root', {
  padding: `0 ${CommonStyles.Sizes.SmallSpace}px ${CommonStyles.Sizes.DefaultSpace}px`
});

const dialogMessageClass = cssClass(cssPrefix, 'dialogMessage', {
  marginBottom: TabStyles.Spacing.LargeSpace,
  wordWrap: 'break-word'
});

const paddingBottomClass = cssClass(cssPrefix, 'paddingBottom', {
  paddingBottom: CommonStyles.Sizes.LargeSpace,
});

const refreshTypeButtonClass = cssClass(cssPrefix, 'refreshTypeButton', {
  width: '250px'
});

enum TableSyncType {
  InSync = 'in-sync',
  Independent = 'independent'
}

export const PublishedConnectionCreateTaskDialogContent: React.FC<{
  dismiss: () => void;
  publishedConnectionInfo?: IPublishedConnectionDetailInfo;
  taskInfo?: IPublishedConnectionTaskInfo;
}> = ({ dismiss, publishedConnectionInfo, taskInfo }) => {

  const [selectedSchedule, setSelectedSchedule] = React.useState('');
  const [tableSyncType, setTableSyncType] = React.useState<TableSyncType>(TableSyncType.InSync);

  const handleSelectSchedule = React.useCallback((value) => setSelectedSchedule(value), []);

  const handleRadioSelect = React.useCallback(
    (value) => {
      setTableSyncType(value);
    },
    []
  );

  const handleCreateTask = React.useCallback(
    () => {
      //TODO: trigger create task action
    },
    []
  );

  const handleEditTask = React.useCallback(
    () => {
      //TODO: trigger edit task action
    },
    []
  );

  const isGoButtonDisabled = React.useMemo(
    () => {
      return !selectedSchedule;
    },
    [selectedSchedule]
  );

  const radioButtonOptions: RadioButtonWithLabelOption<TableSyncType>[] = [
    {
      value: TableSyncType.InSync,
      testId: 'published-connection-table-sync-refresh',
      label: Messages.publishedConnectionTableSyncRefresh()
    },
    {
      value: TableSyncType.Independent,
      testId: 'published-connection-table-independent-refresh',
      label: Messages.publishedConnectionTableIndependentRefresh()
    }
  ];

  return (
    <>
      <div className={rootClass}>
        <div
          className={dialogMessageClass}>{Messages.schedulePublishedConnectionChooseScheduleMessage()}</div>
        <div className={paddingBottomClass}>
          <PublishedConnectionTaskSchedulePicker
            scheduleId={selectedSchedule}
            onSelect={handleSelectSchedule}
          />
        </div>
        <RadioButtonWithLabelGroupWidget
          buttonList={radioButtonOptions}
          className={paddingBottomClass}
          checkedIndex={tableSyncType === TableSyncType.InSync ? 0 : 1}
          handleChange={handleRadioSelect}
        />
      </div>
      <div className={classes(refreshTypeButtonClass, paddingBottomClass)}>
        <PublishedConnectionTaskRefreshTypeDropdown/>
      </div>

      <DialogFooterButtonsWidget
        buttons={[{
          handleClick: dismiss,
          buttonType: ButtonType.Outline,
          children: Messages.cancel(),
          testId: 'schedule-published-connection-task-cancel'
        }, {
          handleClick: taskInfo ? handleEditTask : handleCreateTask,
          buttonType: ButtonType.Primary,
          children: taskInfo ? Messages.editTask() : Messages.schedulePublishedConnectionTask(),
          testId: 'schedule-published-connection-task-go',
          disabled: isGoButtonDisabled
        }]}
        testId={'schedule-published-connection-task-footer'}
      />
    </>
  );
};
PublishedConnectionCreateTaskDialogContent.displayName = 'PublishedConnectionCreateTaskDialogContent';
